export default {
  install(Vue, options) {
    Vue.prototype.$wait = async (timeout) => {
      return new Promise((resolve) => {
        setTimeout(() => resolve(), timeout);
      });
    };
  }
};
